<template lang="pug">
  div.live-list-container
    comp-live-title.live-title
    div.remind(v-if="liveInfoList.length === 0") {{ $t('There is no live yet') }}
    div.container
      comp-live-card(
        v-if="!$isMobile"
        v-for="(item, index) in liveInfoList"
        :key="index"
        :roomInfo="item"
        @chooseRoom="handleLiveRoomChoose(item)"
      )
      comp-live-card-mobile(
        v-if="$isMobile"
        v-for="(item, index) in liveInfoList"
        :key="index"
        :roomInfo="item"
        @chooseRoom="handleLiveRoomChoose(item)"
      )
</template>

<script>
import {
  getRoomList,
  enterRoom,
  logout,
  tokenLogin,
} from '@/api/http';
import Cookies from 'js-cookie';
import compLiveTitle from './components/live-title.vue';
import compLiveCard from './components/live-card.vue';
import compLiveCardMobile from './components/live-card-mobile.vue';
import {
  UPDATE_USER_INFO,
  SET_SDK_APP_ID,
  SET_USER_SIG,
} from '@/constants/mutation-types';
import {
  goToPage,
} from '@/utils/common';
export default {
  name: 'live-list',
  data() {
    return {
      sdkAppId: '',
      userId: '',
      token: '',
      liveInfoList: [],
    };
  },
  components: {
    compLiveTitle,
    compLiveCard,
    compLiveCardMobile,
  },
  methods: {
    // 退出登录
    async handleLogout() {
      const token = Cookies.get('trtc-tuiPlayer-token');
      await logout({
        userId: this.userId,
        token,
      });
      Cookies.remove('trtc-tuiPlayer-token');
      localStorage.removeItem('trtc-tuiPlayer-userInfo');
      localStorage.removeItem('trtc-tuiPlayer-roomInfo');
      goToPage('login');
    },
    async getRoomList() {
      const token = Cookies.get('trtc-tuiPlayer-token');
      const result = await getRoomList({
        sdkAppId: this.sdkAppId,
        userId: this.userId,
        token,
      });
      if (result.errorCode === 0) {
        this.liveInfoList = result.data;
      }
    },
    async handleLiveRoomChoose({ roomId, title }) {
      const token = Cookies.get('trtc-tuiPlayer-token');
      await enterRoom({
        sdkAppId: this.sdkAppId,
        userId: this.userId,
        token,
        roomId,
        role: 'audience',
        title,
      });
      goToPage('player', { roomId });
    },
  },
  async created() {
    const token = Cookies.get('trtc-tuiPlayer-token');
    let userInfo = JSON.parse(localStorage.getItem('trtc-tuiPlayer-userInfo'));
    if (!token || !userInfo) {
      goToPage('login');
    }
    try {
      const result = await tokenLogin({ userId: userInfo.userId, token });
      if (result.errorCode === 0) {
        const { sdkAppId, sdkUserSig, userId, token, name, avatar } = result.data;
        userInfo = {
          sdkAppId,
          userSig: sdkUserSig,
          userId,
          userName: name,
          userAvatar: avatar,
        };
        localStorage.setItem('trtc-tuiPlayer-userInfo', JSON.stringify(userInfo));
        Cookies.set('trtc-tuiPlayer-token', token, { expires: 30 });
      }
    } catch (error) {
      goToPage('login');
    }
    this.$store.commit(UPDATE_USER_INFO, userInfo);
    this.$store.commit(SET_SDK_APP_ID, userInfo.sdkAppId);
    this.$store.commit(SET_USER_SIG, userInfo.userSig);
    this.sdkAppId = userInfo && userInfo.sdkAppId;
    this.userId = userInfo && userInfo.userId;
    await this.getRoomList();
    this.$eventBus.$on('logout', this.handleLogout);
  },
  beforeDestroy() {
    this.$eventBus.$on('logout', this.handleLogout);
  },
};
</script>

<style lang="stylus" scoped>
.live-list-container
  width 100%
  height 100%
  background-color #F3F5F6
  .live-title
    width 100%
    height 52px
    background-color $themeColor
    color $fontColor
  .remind
    width 100%
    padding-top 100px
    text-align center
  .container
    padding 40px 20px 0
    width 100%
    max-width 1480px
    margin 0 auto
    display flex
    flex-wrap wrap
    justify-content flex-start
    align-content flex-start
</style>

<i18n>
{
	"en": {
		"There is no live yet": "There is no live yet"
	},
	"zh": {
		"There is no live yet": "还没有直播间哦"
	}
}
</i18n>
